<input #pdfFile type="file" accept="application/pdf" (change)="readPdf(pdfFile.files!)"/>
<button type="button" (click)="pdfFile.click()" i18n-title title="PDF File" i18n>+</button>
